export default __webpack_public_path__ + "static/media/product_03.3c853bac.jpg";